import type { FC } from 'react';
import React, { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Box, CircularProgress } from '@mui/material';

import { useUserContext } from 'src/components/app/context/UserContext';
import type { PageFrameProps } from 'src/components/common/PageFrame';
import PageFrame from 'src/components/common/PageFrame';
import PageNotFound from 'src/components/common/PageNotFound';
import FIHeader from 'src/components/followUpInspirations/components/FIHeader';
import FilterPage from 'src/components/followUpInspirations/components/FilterPage';
import InspirationsPage from 'src/components/followUpInspirations/components/InspirationsPage';

import useFilterGroupsQuery from '../hooks/useFilterGroupsQuery';

import { styles } from './index.styles';

export const FOLLOW_UP_INSPIRATIONS_PAGE_LOADING_TEST_ID =
  'follow-up-inspirations-page-loading';

export interface FollowUpInspirationsPageProps extends PageFrameProps {}

export const FollowUpInspirationsPage: FC<FollowUpInspirationsPageProps> = ({
  sx,
}) => {
  const { t } = useTranslation('followUpInspirations');
  const { currentSurvey } = useUserContext();

  const [filterResult, setFilterResult] = useState({});
  const { data: filterGroups, isLoading } = useFilterGroupsQuery(currentSurvey);

  return (
    <PageFrame
      className="FollowUpInspirationsPage-root"
      sx={{ ...(Array.isArray(sx) ? sx : [sx]) }}
      header={<FIHeader />}
      pageFrameWidth={1024}
    >
      {currentSurvey?.hasFollowUpInspirations ? (
        <Box sx={{ mt: 4 }}>
          <Box sx={styles.intro}>
            <Trans
              i18nKey="followUpInspirations:introductionText"
              components={{ br: <br />, a: <a /> }}
              values={{
                link: 'https://dpdhl.sharepoint.com/sites/EOSharingHub/SitePages/main.aspx#eosBP',
              }}
            >
              {t('introductionText')}
            </Trans>
          </Box>
          {isLoading ? (
            <>
              <Box
                sx={styles.loadingIndicator}
                data-test-id={FOLLOW_UP_INSPIRATIONS_PAGE_LOADING_TEST_ID}
              >
                <CircularProgress />
              </Box>
            </>
          ) : (
            <>
              <Box
                sx={{
                  mb: 7,
                }}
              >
                <FilterPage
                  onResult={setFilterResult}
                  filterGroups={filterGroups ?? []}
                />
              </Box>
              <Box>
                <InspirationsPage
                  survey={currentSurvey}
                  filterResult={filterResult}
                />
              </Box>
            </>
          )}
        </Box>
      ) : (
        <PageNotFound />
      )}
    </PageFrame>
  );
};

export default FollowUpInspirationsPage;
